const initialState = {
  user: {},
  isAuthenticated: false,
  userRole: '',
  token: '',
  endDate: '',
  isWinner: false,
  count: '',
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USER':
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    case 'SET_USER_ROLE':
      return {
        ...state,
        userRole: action.payload,
      };
    case 'SET_TOKEN':
      return {
        ...state,
        token: action.payload,
      };

    case 'SET_AUCTION_END_DATE':
      return {
        ...state,
        endDate: action.payload,
      };
    case 'SET_IS_WINNER_GENRATED':
      return {
        ...state,
        isWinner: action.payload,
      };
    case 'SET_NOTIFICATION_COUNT':
      return {
        ...state,
        count: action.payload,
      };
    default:
      return state;
  }
};

export default rootReducer;
